// cfg.number_formats — numeric config per value class (currency / fx_rate /
// unit_price / unit_count), delivered via get_global_configs_v3 and amendable
// in cfg without touching code.
//
// TWO settings, deliberately separate:
//   min_decimals / max_decimals  how a figure is DISPLAYED (useNumberDisplay
//     and useNumberFormat). max_decimals truncates the display and leaves the
//     value alone, so it may be coarser than the number behind it.
//   input_decimals  what an EDITED figure may be SAVED as (useNumberFormat
//     only); null/absent = unconstrained.
//
// input_decimals is nullish so the payload validates whether or not the RPC
// emitting it has been deployed yet — this schema is .strict(), and a global
// configs failure takes the whole app down.
import { z } from 'zod'

export const NumberFormatModelSchema = z
  .object({
    key: z.string(),
    label: z.string(),
    min_decimals: z.number(),
    max_decimals: z.number(),
    input_decimals: z.number().nullish()
  })
  .strict()

export type NumberFormatModel = z.infer<typeof NumberFormatModelSchema>
